<template>
  <v-card>
    <Loader ref="Loader"></Loader>
    <ErrorModal ref="ErrorModal"></ErrorModal>
    <v-toolbar dense color="secondary" dark>
      <v-toolbar-title>Permissions</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-sheet class="pa-3 secondary">
      <v-text-field v-model="search" label="Search Permission Tree" dark flat solo-inverted
        hide-details clearable clear-icon="mdi-close-circle-outline"></v-text-field>
      <!-- <v-checkbox color="primary" v-model="caseSensitive" dark hide-details :label="TranslateText('Case sensitive search')"></v-checkbox> -->
    </v-sheet>

    <v-layout>
      <v-flex>
        <v-card-text>
          <v-treeview v-model="selectedTreeItems" :items="items" :search="search" :filter="filter" :open-all="open"
            activatable active-class="grey lighten-4 indigo--text" selected-color="indigo" open-on-click selectable
            expand-icon="mdi-chevron-down" on-icon="mdi-checkbox-marked" off-icon="mdi-checkbox-blank-outline"
            indeterminate-icon="mdi-checkbox-intermediate"></v-treeview>
        </v-card-text>
        <v-card-text>
          <v-treeview v-model="selectedFeatureTreeItems" :items="featureItems" :search="search" activatable
            active-class="grey lighten-4 indigo--text" selected-color="indigo" open-on-click selectable
            expand-icon="mdi-chevron-down" on-icon="mdi-checkbox-marked" off-icon="mdi-checkbox-blank-outline"
            indeterminate-icon="mdi-checkbox-intermediate"></v-treeview>
        </v-card-text>
      </v-flex>

      <v-divider vertical></v-divider>

      <v-flex xs12 md6 hidden-sm-and-down>
        <v-card-text>
          <div class="title font-weight-light success--text pa-3 text-xs-center">
            Selected Role Permissions</div>

          <v-scroll-x-transition group hide-on-leave>
            <v-chip v-for="(selection, i) in selections" :key="i" color="success" dark small>
              <v-icon left small>mdi-beer</v-icon>
              {{ selection.header }} - {{ selection.name }}
            </v-chip>
          </v-scroll-x-transition>

          <!-- <div class="title font-weight-light success--text pa-3 text-xs-center">
            {{TranslateText('Selected Feature Permissions')}}</div>
          <v-scroll-x-transition group hide-on-leave>
            <v-chip v-for="(selection, i) in featureSelections" :key="i" color="success" dark small>
              <v-icon left small>mdi-beer</v-icon>
              {{ selection.header }} - {{ selection.name }}
            </v-chip>
          </v-scroll-x-transition> -->
        </v-card-text>
      </v-flex>
    </v-layout>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="selectedTreeItems = []">Reset</v-btn>
      <v-btn color="success" @click="SavePermissions" depressed>
        Save
        <v-icon right>mdi-content-save</v-icon>
      </v-btn>
      <v-btn flat @click="RouteTo('/roles/dashboard')">Cancel</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import JWT from "jsonwebtoken";

  export default {
    data: () => ({
      systemModules: [],
      AccountFeatures: [],
      FeatureModules: [],
      featureItems: [],
      isLoading: false,
      selectedTreeItems: [],
      selectedFeatureTreeItems: [],
      search: null,
      caseSensitive: false,
      rolePermissionArr: [],
      roleFeaturePermissionArr: [],
      RoleID: null,
      ID: null,
      SystemModuleID: null,
      AllPermissions: [],
      AllFeaturePermissions: [],
      open: false
    }),

    computed: {
      filter() {
        return this.caseSensitive ?
          (item, search, textKey) => item[textKey].indexOf(search) > -1 :
          undefined;
      },
      items() {
        let self = this;

        const children = this.systemModules.map(sysModule => ({
          id: self.guid(), //sysModule.ID,
          SystemModuleID: sysModule.ID,
          header: sysModule.Name,
          name: sysModule.Name,
          code: sysModule.Code,
          children: self.getAllChildrenForModule(sysModule)
        }));

        return [{
          id: this.$route.params.id,
          name: "All Role Permissions",
          children
        }];
      },
      selections() {
        let self = this;
        const selections = [];
        for (const leaf of this.selectedTreeItems) {
          let permission = this.AllPermissions.find(
            permission => permission.id === leaf
          );

          if (!permission) {
            continue;
          }

          selections.push(permission);
        }

        return selections;
      },
      // featureSelections() {
      //   let self = this;
      //   const selections = [];
      //   for (const leaf of this.selectedFeatureTreeItems) {
      //     let permission = this.AllFeaturePermissions.find(
      //       permission => permission.id === leaf
      //     );

      //     if (!permission) {
      //       continue;
      //     }

      //     selections.push(permission);
      //   }

      //   return selections;
      // },
      shouldShowTree() {
        return this.systemModules.length > 0 && !this.isLoading;
      }
    },
    mounted() {
      let self = this;
      self.RoleID = self.$route.params.id;

      self
        .fetchSystemModules()
        .then(response => {
          self
            .getRolePermissions()
            .then(rpResponse => {
              self.open = true;
            })
            .catch(rpError => {});
        })
        .catch(error => {});

      // self.fetchAccountFeatures().then(response => {
      //   self.fetchFeatureRolePermissions();
      // });
    },
    methods: {
      fetchSystemModules() {
        let self = this;

        return new Promise((resolve, reject) => {
          self.$refs.Loader.show();
          self
            .get("SystemModules")
            .then(response => {
              self.$refs.Loader.hide();
              console.log("[SYSTEM-MODULES]", response.data);
              self.systemModules = response.data;
              resolve(true);
            })
            .catch(error => {
              self.$refs.Loader.hide();
              self.$refs.ErrorModal.show();
              self.$refs.ErrorModal.setText(error.toString());
              reject(error);
            });
        });
      },
      // fetchAccountFeatures() {
      //   let self = this;

      //   return new Promise((resolve, reject) => {
      //     self.$refs.Loader.show();
      //     let AccountID = JWT.decode(localStorage["accessToken"]).ACCOUNT_ID;
      //     self
      //       .get(`AccountFeature/ActiveFeatures?accountID=${AccountID}`)
      //       .then(response => {
      //         self.$refs.Loader.hide();
      //         console.log("[SYSTEM-FEATURES]", response.data);
      //         self.AccountFeatures = response.data;

      //         const children = this.AccountFeatures.map(accFeature => ({
      //           id: self.guid(), //accFeature.ID,
      //           SystemModuleID: accFeature.ID,
      //           header: accFeature.Name,
      //           name: self.TranslateText(accFeature.Name),
      //           code: accFeature.Code,
      //           children: self.getAllChildrenForFeatureModule(accFeature)
      //         }));

      //         self.featureItems = [{
      //           id: self.$route.params.id,
      //           name: "Feature Permissions",
      //           children
      //         }];
      //         resolve(true);
      //       })
      //       .catch(error => {
      //         self.$refs.Loader.hide();
      //         self.$refs.ErrorModal.show();
      //         self.$refs.ErrorModal.setText(error.toString());
      //         reject(error);
      //       });
      //   });
      // },
      getRolePermissions() {
        let self = this;

        return new Promise((resolve, reject) => {
          self.$refs.Loader.show();
          self
            .get(`RolePermissions/Role?roleID=${self.RoleID}`)
            .then(response => {
              self.$refs.Loader.hide();
              self.rolePermissionArr = response.data;

              self.setDatabaseSelectedItems(response.data);

              resolve(true);
            })
            .catch(error => {
              self.$refs.Loader.hide();
              self.$refs.ErrorModal.show();
              self.$refs.ErrorModal.setText(error.toString());
              reject(error);
            });
        });
      },
      fetchFeatureRolePermissions() {
        let self = this;

        return new Promise((resolve, reject) => {
          self.$refs.Loader.show();
          self
            .get(`FeatureRolePermission?roleID=${self.RoleID}`)
            .then(response => {
              self.$refs.Loader.hide();
              self.roleFeaturePermissionArr = response.data;

              console.log(self.roleFeaturePermissionArr);

              self.setDatabaseSelectedFeatureItems(response.data);

              resolve(true);
            })
            .catch(error => {
              self.$refs.Loader.hide();
              self.$refs.ErrorModal.show();
              self.$refs.ErrorModal.setText(error.toString());
              reject(error);
            });
        });
      },
      getAllChildrenForModule(sysModule) {
        let self = this;
        let arr = [];
        let exists = self.rolePermissionArr.filter(rolePermission => {
          return rolePermission.SystemModuleID == sysModule.ID;
        });

        if (exists.length > 0) {
          self.constructSingle(arr, sysModule, exists[0]);
        } else {
          self.constructSingle(arr, sysModule, undefined);
        }

        return arr;
      },
      getAllChildrenForFeatureModule(accFeature) {
        let self = this;
        let arr = [];

        self
          .get(`FeatureModule?featureID=${accFeature.ID}`)
          .then(featureModuleResponse => {
            featureModuleResponse.data.forEach(el => {
              self.FeatureModules.push(el);
              //self.$set(el, "children", []);
              let children = [];
              self.constructSingleFeature(children, el, undefined);

              arr.push({
                id: self.guid(), //accFeature.ID,
                SystemModuleID: el.ID,
                header: el.Name,
                name: el.Name,
                code: el.Code,
                children: children
              });
            });
          });

        //self.constructSingleFeature(arr, accFeature, undefined);
        return arr;
      },
      constructSingle(arr, sysModule, exists) {
        let self = this;
        switch (sysModule.Code.toUpperCase()) {
        case "USER_MANAGEMENT": {
          self.createPermissionEasy(
            arr,
            sysModule,
            exists,
            true,
            true,
            true,
            true
          );
        }
        break;
        case "ROLE_MANAGEMENT": {
          self.createPermissionEasy(
            arr,
            sysModule,
            exists,
            true,
            true,
            true,
            true
          );
        }
        break;
        case "PERMISSION_MANAGEMENT": {
          self.createPermissionEasy(
            arr,
            sysModule,
            exists,
            true,
            false,
            true
          );
        }
        break;
        case "REPORT_DASHBOARD": {
          self.createPermissionEasy(arr, sysModule, exists, true);
        }
        break;
        case "FEEDBACK": {
          self.createPermissionEasy(
            arr,
            sysModule,
            exists,
            true,
            false,
            true
          );
        }
        break;
        case "CUSTOMER_MANAGEMENT": {
          self.createPermissionEasy(
            arr,
            sysModule,
            exists,
            true,
            true,
            true,
            true
          );
        }
        break;
        case "INSPECTION_MANAGEMENT": {
          self.createPermissionEasy(
            arr,
            sysModule,
            exists,
            true,
            true,
            true,
            true
          );
        }
        break;
        case "CLASS_MANAGEMENT": {
          self.createPermissionEasy(
            arr,
            sysModule,
            exists,
            true,
            true,
            true
          );
        }
        break;
        case "OPS_MANAGER_ALLOCATION_MANAGEMENT": {
          self.createPermissionEasy(
            arr,
            sysModule,
            exists,
            true,
            true,
            true
          );
        }
        break;
        case "SUPERVISOR_ALLOCATION_MANAGEMENT": {
          self.createPermissionEasy(
            arr,
            sysModule,
            exists,
            true,
            true,
            true
          );
        }
        break;
        }
      },
      constructSingleFeature(arr, accFeature, exists) {
        let self = this;
        switch (accFeature.Code.toUpperCase()) {
          case "MODULE1": {
            self.createFeaturePermissionEasy(
              arr,
              accFeature,
              exists,
              true,
              true,
              true,
              true
            );
          }
          break;
        }
      },
      createPermissionEasy(
        arr,
        sysModule,
        exists,
        view,
        create,
        modify,
        del,
        report,
        suspend,
        auth,
        extend
      ) {
        let self = this;

        if (view) {
          let item = {
            id: sysModule.ID + "-" + "CanView",
            SystemModuleID: sysModule.ID,
            header: sysModule.Name,
            name: "Can View",
            code: sysModule.Code,
            PermCode: "CanView",
            value: exists == undefined ? false : exists.CanView
          };

          arr.push(item);
          self.AllPermissions.push(item);
        }

        if (create) {
          let item = {
            id: sysModule.ID + "-" + "CanCreate",
            SystemModuleID: sysModule.ID,
            header: sysModule.Name,
            name: "Can Create",
            code: sysModule.Code,
            PermCode: "CanCreate",
            value: exists == undefined ? false : exists.CanCreate
          };

          arr.push(item);
          self.AllPermissions.push(item);
        }

        if (modify) {
          let item = {
            id: sysModule.ID + "-" + "CanModify",
            SystemModuleID: sysModule.ID,
            header: sysModule.Name,
            name: "Can Modify",
            code: sysModule.Code,
            PermCode: "CanModify",
            value: exists == undefined ? false : exists.CanModify
          };

          arr.push(item);
          self.AllPermissions.push(item);
        }

        if (del) {
          let item = {
            id: sysModule.ID + "-" + "CanDelete",
            SystemModuleID: sysModule.ID,
            header: sysModule.Name,
            name: "Can Delete",
            code: sysModule.Code,
            PermCode: "CanDelete",
            value: exists == undefined ? false : exists.CanDelete
          };

          arr.push(item);
          self.AllPermissions.push(item);
        }

        if (report) {
          let item = {
            id: sysModule.ID + "-" + "CanReport",
            SystemModuleID: sysModule.ID,
            header: sysModule.Name,
            name: "Can Report",
            code: sysModule.Code,
            PermCode: "CanReport",
            value: exists == undefined ? false : exists.CanReport
          };

          arr.push(item);
          self.AllPermissions.push(item);
        }

        if (suspend) {
          let item = {
            id: sysModule.ID + "-" + "CanSuspend",
            SystemModuleID: sysModule.ID,
            header: sysModule.Name,
            name: "Can Suspend",
            code: sysModule.Code,
            PermCode: "CanSuspend",
            value: exists == undefined ? false : exists.CanSuspend
          };

          arr.push(item);
          self.AllPermissions.push(item);
        }

        if (auth) {
          let item = {
            id: sysModule.ID + "-" + "CanAuthorise",
            SystemModuleID: sysModule.ID,
            header: sysModule.Name,
            name: "Can Authorise",
            code: sysModule.Code,
            PermCode: "CanAuthorise",
            value: exists == undefined ? false : exists.CanAuthorise
          };

          arr.push(item);
          self.AllPermissions.push(item);
        }

        if (extend) {
          let item = {
            id: sysModule.ID + "-" + "CanExtend",
            SystemModuleID: sysModule.ID,
            header: sysModule.Name,
            name: "Can Extend",
            code: sysModule.Code,
            PermCode: "CanExtend",
            value: exists == undefined ? false : exists.CanExtend
          };

          arr.push(item);
          self.AllPermissions.push(item);
        }
      },
      createFeaturePermissionEasy(
        arr,
        sysModule,
        exists,
        view,
        create,
        modify,
        del,
        report,
        suspend,
        auth,
        extend
      ) {
        let self = this;

        console.log(arr, sysModule);

        if (view) {
          let item = {
            id: sysModule.ID + "-" + "CanView",
            FeatureID: sysModule.ID,
            header: sysModule.Name,
            name: "Can View",
            code: sysModule.Code,
            PermCode: "CanView",
            value: exists == undefined ? false : exists.CanView
          };

          arr.push(item);
          self.AllFeaturePermissions.push(item);
        }

        if (create) {
          let item = {
            id: sysModule.ID + "-" + "CanCreate",
            FeatureID: sysModule.ID,
            header: sysModule.Name,
            name: "Can Create",
            code: sysModule.Code,
            PermCode: "CanCreate",
            value: exists == undefined ? false : exists.CanCreate
          };

          arr.push(item);
          self.AllFeaturePermissions.push(item);
        }

        if (modify) {
          let item = {
            id: sysModule.ID + "-" + "CanModify",
            FeatureID: sysModule.ID,
            header: sysModule.Name,
            name: "Can Modify",
            code: sysModule.Code,
            PermCode: "CanModify",
            value: exists == undefined ? false : exists.CanModify
          };

          arr.push(item);
          self.AllFeaturePermissions.push(item);
        }

        if (del) {
          let item = {
            id: sysModule.ID + "-" + "CanDelete",
            FeatureID: sysModule.ID,
            header: sysModule.Name,
            name: "Can Delete",
            code: sysModule.Code,
            PermCode: "CanDelete",
            value: exists == undefined ? false : exists.CanDelete
          };

          arr.push(item);
          self.AllFeaturePermissions.push(item);
        }

        if (report) {
          let item = {
            id: sysModule.ID + "-" + "CanReport",
            FeatureID: sysModule.ID,
            header: sysModule.Name,
            name: "Can Report",
            code: sysModule.Code,
            PermCode: "CanReport",
            value: exists == undefined ? false : exists.CanReport
          };

          arr.push(item);
          self.AllFeaturePermissions.push(item);
        }

        if (suspend) {
          let item = {
            id: sysModule.ID + "-" + "CanSuspend",
            FeatureID: sysModule.ID,
            header: sysModule.Name,
            name: "Can Suspend",
            code: sysModule.Code,
            PermCode: "CanSuspend",
            value: exists == undefined ? false : exists.CanSuspend
          };

          arr.push(item);
          self.AllFeaturePermissions.push(item);
        }

        if (auth) {
          let item = {
            id: sysModule.ID + "-" + "CanAuthorise",
            FeatureID: sysModule.ID,
            header: sysModule.Name,
            name: "Can Authorise",
            code: sysModule.Code,
            PermCode: "CanAuthorise",
            value: exists == undefined ? false : exists.CanAuthorise
          };

          arr.push(item);
          self.AllFeaturePermissions.push(item);
        }

        if (extend) {
          let item = {
            id: sysModule.ID + "-" + "CanExtend",
            FeatureID: sysModule.ID,
            header: sysModule.Name,
            name: "Can Extend",
            code: sysModule.Code,
            PermCode: "CanExtend",
            value: exists == undefined ? false : exists.CanExtend
          };

          arr.push(item);
          self.AllFeaturePermissions.push(item);
        }
      },
      setDatabaseSelectedItems(dbDataList) {
        let self = this;
        dbDataList.forEach(el => {
          if (el.CanView == true) {
            self.selectedTreeItems.push(el.SystemModuleID + "-" + "CanView");
          }

          if (el.CanCreate == true) {
            self.selectedTreeItems.push(el.SystemModuleID + "-" + "CanCreate");
          }

          if (el.CanModify == true) {
            self.selectedTreeItems.push(el.SystemModuleID + "-" + "CanModify");
          }

          if (el.CanDelete == true) {
            self.selectedTreeItems.push(el.SystemModuleID + "-" + "CanDelete");
          }

          if (el.CanReport == true) {
            self.selectedTreeItems.push(el.SystemModuleID + "-" + "CanReport");
          }

          if (el.CanSuspend == true) {
            self.selectedTreeItems.push(el.SystemModuleID + "-" + "CanSuspend");
          }

          if (el.CanAuthorise == true) {
            self.selectedTreeItems.push(el.SystemModuleID + "-" + "CanAuthorise");
          }

          if (el.CanExtend == true) {
            self.selectedTreeItems.push(el.SystemModuleID + "-" + "CanExtend");
          }
        });
      },
      setDatabaseSelectedFeatureItems(dbDataList) {
        let self = this;
        dbDataList.forEach(el => {
          if (el.CanView == true) {
            self.selectedFeatureTreeItems.push(el.FeatureID + "-" + "CanView");
          }

          if (el.CanCreate == true) {
            self.selectedFeatureTreeItems.push(el.FeatureID + "-" + "CanCreate");
          }

          if (el.CanModify == true) {
            self.selectedFeatureTreeItems.push(el.FeatureID + "-" + "CanModify");
          }

          if (el.CanDelete == true) {
            self.selectedFeatureTreeItems.push(el.FeatureID + "-" + "CanDelete");
          }

          if (el.CanReport == true) {
            self.selectedFeatureTreeItems.push(el.FeatureID + "-" + "CanReport");
          }

          if (el.CanSuspend == true) {
            self.selectedFeatureTreeItems.push(el.FeatureID + "-" + "CanSuspend");
          }

          if (el.CanAuthorise == true) {
            self.selectedFeatureTreeItems.push(
              el.FeatureID + "-" + "CanAuthorise"
            );
          }

          if (el.CanExtend == true) {
            self.selectedFeatureTreeItems.push(el.FeatureID + "-" + "CanExtend");
          }
        });
      },
      SavePermissions() {
        let self = this;
        let tmpList = self.selections.sort(
          (a, b) => a.SystemModuleID - b.SystemModuleID
        );
        // let tmpFeatureList = self.featureSelections.sort(
        //   (a, b) => a.FeatureID - b.FeatureID
        // );
        let saveList = [];
        let saveFeatureList = [];

        let prevModuleID = null;

        self.FeatureModules.forEach(element => {
          let currentItem = {};
          currentItem["UserRoleID"] = self.RoleID;
          currentItem["FeatureID"] = element.FeatureID;
          currentItem["FeatureModuleID"] = element.ID;
          currentItem["CanView"] =
            tmpFeatureList.find(
              item => item.PermCode === "CanView" && item.FeatureID == element.ID
            ) == undefined ?
            false :
            true;
          currentItem["CanCreate"] =
            tmpFeatureList.find(
              item =>
              item.PermCode === "CanCreate" && item.FeatureID == element.ID
            ) == undefined ?
            false :
            true;
          currentItem["CanModify"] =
            tmpFeatureList.find(
              item =>
              item.PermCode === "CanModify" && item.FeatureID == element.ID
            ) == undefined ?
            false :
            true;
          currentItem["CanDelete"] =
            tmpFeatureList.find(
              item =>
              item.PermCode === "CanDelete" && item.FeatureID == element.ID
            ) == undefined ?
            false :
            true;
          currentItem["CanReport"] =
            tmpFeatureList.find(
              item =>
              item.PermCode === "CanReport" && item.FeatureID == element.ID
            ) == undefined ?
            false :
            true;
          currentItem["CanAuthorise"] =
            tmpFeatureList.find(
              item =>
              item.PermCode === "CanAuthorise" && item.FeatureID == element.ID
            ) == undefined ?
            false :
            true;
          currentItem["CanSuspend"] =
            tmpFeatureList.find(
              item =>
              item.PermCode === "CanSuspend" && item.FeatureID == element.ID
            ) == undefined ?
            false :
            true;
          currentItem["CanExtend"] =
            tmpFeatureList.find(
              item =>
              item.PermCode === "CanExtend" && item.FeatureID == element.ID
            ) == undefined ?
            false :
            true;

          saveFeatureList.push(currentItem);
        });

        self.systemModules.forEach(element => {
          let currentItem = {};
          currentItem["UserRoleID"] = self.RoleID;
          currentItem["SystemModuleID"] = element.ID;
          currentItem["CanView"] =
            tmpList.find(
              item =>
              item.PermCode === "CanView" && item.SystemModuleID == element.ID
            ) == undefined ?
            false :
            true;
          currentItem["CanCreate"] =
            tmpList.find(
              item =>
              item.PermCode === "CanCreate" && item.SystemModuleID == element.ID
            ) == undefined ?
            false :
            true;
          currentItem["CanModify"] =
            tmpList.find(
              item =>
              item.PermCode === "CanModify" && item.SystemModuleID == element.ID
            ) == undefined ?
            false :
            true;
          currentItem["CanDelete"] =
            tmpList.find(
              item =>
              item.PermCode === "CanDelete" && item.SystemModuleID == element.ID
            ) == undefined ?
            false :
            true;
          currentItem["CanReport"] =
            tmpList.find(
              item =>
              item.PermCode === "CanReport" && item.SystemModuleID == element.ID
            ) == undefined ?
            false :
            true;
          currentItem["CanAuthorise"] =
            tmpList.find(
              item =>
              item.PermCode === "CanAuthorise" &&
              item.SystemModuleID == element.ID
            ) == undefined ?
            false :
            true;
          currentItem["CanSuspend"] =
            tmpList.find(
              item =>
              item.PermCode === "CanSuspend" &&
              item.SystemModuleID == element.ID
            ) == undefined ?
            false :
            true;
          currentItem["CanExtend"] =
            tmpList.find(
              item =>
              item.PermCode === "CanExtend" && item.SystemModuleID == element.ID
            ) == undefined ?
            false :
            true;

          saveList.push(currentItem);
        });

        self.$refs.Loader.show(true);
        self.$refs.Loader.setText("Saving permissions...");
        self
          .post("RolePermissions", saveList)
          .then(result => {
            self.$refs.Loader.hide();

            if (result.data == true) {
              self.RouteTo("/roles/dashboard");
            } else {
              self.$refs.ErrorModal.show();
              self.$refs.ErrorModal.setText(
                  "Permissions were not saved. Please check the log files on the server."
                
              );
            }
          })
          .catch(error => {
            self.$refs.ErrorModal.show();
            self.$refs.ErrorModal.setText(error.toString());
          });

        // self
        //   .post("FeatureRolePermission", saveFeatureList)
        //   .then(result => {
        //     if (result.data == true) {
        //       self.RouteTo("/roles/dashboard");
        //     } else {
        //       self.$refs.ErrorModal.show();
        //       self.$refs.ErrorModal.setText(
        //         self.TranslateText(
        //           "Permissions were not saved. Please check the log files on the server."
        //         )
        //       );
        //     }
        //   })
        //   .catch(error => {
        //     self.$refs.ErrorModal.show();
        //     self.$refs.ErrorModal.setText(error.toString());
        //   });
      },
      RouteTo(route) {
        let self = this;
        self.$router.push(route);
      },
      getName(name) {
        return `${name.charAt(0).toUpperCase()}${name.slice(1)}`;
      },
      guid() {
        function s4() {
          return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
        }
        return (
          s4() +
          s4() +
          "-" +
          s4() +
          "-" +
          s4() +
          "-" +
          s4() +
          "-" +
          s4() +
          s4() +
          s4()
        );
      }
    }
  };
</script>